<main class="esf-main-content esf-main-content--has-sidebar -has-transition" style="width: 100vw" [class.-is-open]="isOpened">
  <div class="esf-container main-content--full-screen" [class.full-screen-opened]="isOpened">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span class="esf-action-heading__text" i18n="@@tixxSelect.heading.lotteryExecution">
        Lottery Execution
      </span>
    </h1>

    <ul class="esf-progress-indicator top-margin">
      <li class="esf-progress-indicator__step" [ngClass]="{'-is-complete': stepProcess > 1, '-is-current': stepProcess === 1}">
        <div class="esf-progress-indicator__item">
          <div class="esf-progress-indicator__count">
            <div class="esf-progress-indicator__count-inner">
              <div class="esf-progress-indicator__number">1</div>
            </div>
          </div>
        </div>
        <div class="esf-progress-indicator__item esf-progress-indicator__item--label">
          <span class="esf-progress-indicator__label" i18n='lotteryExecution.stepProcess.filterRequests'>Filter requests</span>
        </div>
        <div class="esf-progress-indicator__item esf-progress-indicator__item--separator">
          <div class="esf-progress-indicator__separator"></div>
        </div>
      </li>
      <li class="esf-progress-indicator__step" [ngClass]="{'-is-complete': stepProcess > 2, '-is-current': stepProcess === 2}">
        <div class="esf-progress-indicator__item">
          <div class="esf-progress-indicator__count">
            <div class="esf-progress-indicator__count-inner">
              <div class="esf-progress-indicator__number">2</div>
            </div>
          </div>
        </div>
        <div class="esf-progress-indicator__item esf-progress-indicator__item--label">
          <span class="esf-progress-indicator__label" i18n='lotteryExecution.stepProcess.lotteryExecution'>Lottery execution</span>
        </div>
        <div class="esf-progress-indicator__item esf-progress-indicator__item--separator">
          <div class="esf-progress-indicator__separator"></div>
        </div>
      </li>
    </ul>

    <div class="form-wrapper">
      <app-filter-requests *ngIf="stepProcess === 1"
                           [selectedLottery]="selectedLottery"
                           [selectedClub]="selectedClub"
                           [customQueries]="customQueries"
                           [executionSummary]="executionSummary"
                           (executionSummaryEmitter)="executionSummary = $event"
                           (savedFilteredFormEmitter)="savedFilteredForm = $event"
                           (savedDeviationFormEmitter)="savedDeviationForm = $event"
                           (iterationSubmissionFiltersEmitter)="iterationSubmissionFilters = $event"
                           (nextStepEmitter)="goForwardAStep()"
                           (openResultsTableEmitter)="openResultsTable()">
      </app-filter-requests>
      <app-lottery-settings *ngIf="stepProcess === 2"
                            [selectedLottery]="selectedLottery"
                            [selectedClub]="selectedClub"
                            [executionSummary]="executionSummary"
                            [savedFilteredForm]="savedFilteredForm"
                            [savedDeviationForm]="savedDeviationForm"
                            [iterationSubmissionFilters]="iterationSubmissionFilters"
                            (nextStepEmitter)="goForwardAStep()"
                            (backStepEmitter)="goBackAStep()">
      </app-lottery-settings>
    </div>
  </div>
</main>

<app-local-modal
                 [showSubmitButton]="false"
                 [title]="i18nModalTitle"
                 [large]="true">
  <app-paginated-table [columns]="columns"
                       [keys]="keys"
                       [data]="currentSubmissions"
                       [initialLoad]="false"

                       [baseApi]="baseApi"
                       [customQueries]="customQueries"
                       (dataFetchedEmitter)="createSubmissionObject($event)"

                       [emptyStateText]="i18nEmptyState"
                       [emptyStateIcon]="'#esf-icon-clover-leaf-48'">

  </app-paginated-table>
</app-local-modal>
